'use client'

import React, { useEffect } from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { Button, IconButton, useDisclosure } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'
import { MdMenu } from 'react-icons/md';
import { useTranslation } from '../i18n/LanguageContext';
import { trackUmamiEvent } from '../lib/analytics/umami';
import { handleAuthRedirectClick } from '../lib/navigation/externalBrowser';

export default function HeaderMenuMobile() {

  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  const { t } = useTranslation();

  useEffect(() => {
    onClose();
  }, [location.pathname])

  return (
    <Flex
      as="nav"
      aria-label={t("nav.mainAria")}
      flexDirection={"row"}
      alignItems={"center"}
    >
      <IconButton
        variant="greyTransparent"
        color="text.medium.grey"
        fontSize='16px'
        icon={<MdMenu />}
        onClick={() => {
          trackUmamiEvent("navigation_click", { location: "header_mobile", destination: "menu_open" });
          onOpen();
        }}
        ref={btnRef}
        aria-label={t("nav.openMenu")}
      />
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody
            px={0}
            mt={"40px"}
            w="100%"
             >
            <Link to="/">
              <Text
                fontSize={"16px"}
                height={"50px"}
                color={(
                  location.pathname.includes('home') ? 'fill.coral' : 'text.medium.dark'
                )}
                bg={(
                  location.pathname.includes('home') ? 'background.coral' : 'white'
                )}
                px={3}
                lineHeight={"50px"}
              >{t("nav.home")}</Text>
            </Link>
            <Link to="/features">
              <Text
                fontSize={"16px"}
                height={"50px"}
                color={(
                  location.pathname.includes('features') ? 'fill.coral' : 'text.medium.dark'
                )}
                bg={(
                  location.pathname.includes('features') ? 'background.coral' : 'white'
                )}
                px={3}
                lineHeight={"50px"}
              >{t("nav.features")}</Text>
            </Link>
            <Link to="/pricing">
              <Text
                fontSize={"16px"}
                height={"50px"}
                color={(
                  location.pathname.includes('pricing') ? 'fill.coral' : 'text.medium.dark'
                )}
                bg={(
                  location.pathname.includes('pricing') ? 'background.coral' : 'white'
                )}
                px={3}
                lineHeight={"50px"}
              >{t("nav.pricing")}</Text>
            </Link>
            <Link
              to="https://support.bibliona.com/"
              target='_blank'
              onClick={() => trackUmamiEvent("navigation_click", { location: "header_mobile", destination: "support" })}
            >
              <Text
                fontSize={"16px"}
                height={"50px"}
                color={(
                  location.pathname.includes('support') ? 'fill.coral' : 'text.medium.dark'
                )}
                bg={(
                  location.pathname.includes('pricing') ? 'background.coral' : 'white'
                )}
                px={3}
                lineHeight={"50px"}
                >{t("nav.support")}</Text>
            </Link>
            <Link
              to={process.env.REACT_APP_BIBLIONA_URL + '/auth/sign-up'}
              target='_blank'
              onClick={() => trackUmamiEvent("cta_click", { location: "header_mobile", cta: "sign_up" })}
            >
              <Button variant="coralOutline" mx={"15px"} w="calc(100% - 30px)" mb={"15px"}>{t("nav.signUp")}</Button>
            </Link>
            <Link
              to={process.env.REACT_APP_BIBLIONA_URL}
              target='_blank'
              onClick={(event) =>
                handleAuthRedirectClick(event, process.env.REACT_APP_BIBLIONA_URL, () =>
                  trackUmamiEvent("cta_click", { location: "header_mobile", cta: "sign_in" })
                )
              }
            >
              <Button variant="coralFill" mx={"15px"} w="calc(100% - 30px)">{t("nav.signIn")}</Button>
            </Link>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
